import { sendGetRequest, sendPostRequest } from "services/apiService";

interface IGenerateToken {
  kind: string;
}

export interface IAuthToken {
  token: string;
  kind: string;
  expiresAt?: number;
}

const generateAppToken = (kind: string) =>
  sendPostRequest<IGenerateToken, IAuthToken>("/auth-token/generate", { kind });

const getAppTokenList = () =>
  sendGetRequest<APIResponse<{ tokens: IAuthToken[] }>>("/auth-token/list");

export default {
  generateAppToken,
  getAppTokenList,
};
